/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SecureRouteImport } from './routes/secure'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppFinanceRouteImport } from './routes/_app/finance'
import { Route as AppMessagesRouteImport } from './routes/_app/messages'
import { Route as AppNewsRouteImport } from './routes/_app/news'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppTodayRouteImport } from './routes/_app/today'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppCatalogIndexRouteImport } from './routes/_app/catalog/index'
import { Route as AppCatalogIdRouteImport } from './routes/_app/catalog/$id'
import { Route as AppCatalogCasesRouteImport } from './routes/_app/catalog/cases'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppClientsIdRouteImport } from './routes/_app/clients/$id'
import { Route as AppDocumentsIndexRouteImport } from './routes/_app/documents/index'
import { Route as AppDocumentsIdRouteImport } from './routes/_app/documents/$id'
import { Route as AppMailIndexRouteImport } from './routes/_app/mail/index'
import { Route as AppMessagesIndexRouteImport } from './routes/_app/messages/index'
import { Route as AppMessagesConversationIdRouteImport } from './routes/_app/messages/$conversationId'
import { Route as AppMessagesThreadsRouteImport } from './routes/_app/messages/threads'
import { Route as AppProfileIndexRouteImport } from './routes/_app/profile/index'
import { Route as AppProfileDocumentsRouteImport } from './routes/_app/profile/documents'
import { Route as AppProfileMailRouteImport } from './routes/_app/profile/mail'
import { Route as AppProfileSecurityRouteImport } from './routes/_app/profile/security'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsIdRouteImport } from './routes/_app/projects/$id'
import { Route as AppSalesIndexRouteImport } from './routes/_app/sales/index'
import { Route as AppSalesEstimatesRouteImport } from './routes/_app/sales/estimates'
import { Route as AppSalesLeadsRouteImport } from './routes/_app/sales/leads'
import { Route as AppSalesPipelineRouteImport } from './routes/_app/sales/pipeline'
import { Route as AppSalesSummaryRouteImport } from './routes/_app/sales/summary'
import { Route as AppSalesTouchesRouteImport } from './routes/_app/sales/touches'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAcquiringRouteImport } from './routes/_app/settings/acquiring'
import { Route as AppSettingsAiRouteImport } from './routes/_app/settings/ai'
import { Route as AppSettingsBankRouteImport } from './routes/_app/settings/bank'
import { Route as AppSettingsCalendarRouteImport } from './routes/_app/settings/calendar'
import { Route as AppSettingsCoefficientsRouteImport } from './routes/_app/settings/coefficients'
import { Route as AppSettingsDadataRouteImport } from './routes/_app/settings/dadata'
import { Route as AppSettingsDocumentsRouteImport } from './routes/_app/settings/documents'
import { Route as AppSettingsEdoRouteImport } from './routes/_app/settings/edo'
import { Route as AppSettingsFinanceRouteImport } from './routes/_app/settings/finance'
import { Route as AppSettingsMailRouteImport } from './routes/_app/settings/mail'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsPricingRouteImport } from './routes/_app/settings/pricing'
import { Route as AppSettingsProductionRouteImport } from './routes/_app/settings/production'
import { Route as AppSettingsProposalsRouteImport } from './routes/_app/settings/proposals'
import { Route as AppSettingsRolesRouteImport } from './routes/_app/settings/roles'
import { Route as AppSettingsSalesRouteImport } from './routes/_app/settings/sales'
import { Route as AppSettingsSiteRouteImport } from './routes/_app/settings/site'
import { Route as AppSettingsSpecializationsRouteImport } from './routes/_app/settings/specializations'
import { Route as AppSettingsStudioRouteImport } from './routes/_app/settings/studio'
import { Route as AppSettingsTaxRouteImport } from './routes/_app/settings/tax'
import { Route as AppTeamIndexRouteImport } from './routes/_app/team/index'
import { Route as AppTeamIdRouteImport } from './routes/_app/team/$id'
import { Route as AppEstimatesRequestsIndexRouteImport } from './routes/_app/estimates/requests/index'
import { Route as AppEstimatesRequestsIdRouteImport } from './routes/_app/estimates/requests/$id'
import { Route as AppMailMailboxIdFolderRouteImport } from './routes/_app/mail/$mailboxId.$folder'
import { Route as AppSalesDealsIdRouteImport } from './routes/_app/sales/deals/$id'
import { Route as AppProjectsIdTasksTaskIdRouteImport } from './routes/_app/projects/$id.tasks.$taskId'
import { Route as AppSalesDealsIdBriefRouteImport } from './routes/_app/sales/deals/$id_.brief'
import { Route as AppSalesDealsIdContractRouteImport } from './routes/_app/sales/deals/$id_.contract'
import { Route as AppSalesDealsIdEstimateRouteImport } from './routes/_app/sales/deals/$id_.estimate'
import { Route as AppSalesDealsIdProposalRouteImport } from './routes/_app/sales/deals/$id_.proposal'
import { Route as AppSalesDealsIdQuickRouteImport } from './routes/_app/sales/deals/$id_.quick'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureRoute = SecureRouteImport.update({
  id: '/secure',
  path: '/secure',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceRoute = AppFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppNewsRoute = AppNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppTodayRoute = AppTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AppRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogIndexRoute = AppCatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogIdRoute = AppCatalogIdRouteImport.update({
  id: '/catalog/$id',
  path: '/catalog/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogCasesRoute = AppCatalogCasesRouteImport.update({
  id: '/catalog/cases',
  path: '/catalog/cases',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIdRoute = AppClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIdRoute = AppDocumentsIdRouteImport.update({
  id: '/documents/$id',
  path: '/documents/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMailIndexRoute = AppMailIndexRouteImport.update({
  id: '/mail/',
  path: '/mail/',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesIndexRoute = AppMessagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMessagesRoute,
} as any)
const AppMessagesConversationIdRoute =
  AppMessagesConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AppMessagesRoute,
  } as any)
const AppMessagesThreadsRoute = AppMessagesThreadsRouteImport.update({
  id: '/threads',
  path: '/threads',
  getParentRoute: () => AppMessagesRoute,
} as any)
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileDocumentsRoute = AppProfileDocumentsRouteImport.update({
  id: '/profile/documents',
  path: '/profile/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileMailRoute = AppProfileMailRouteImport.update({
  id: '/profile/mail',
  path: '/profile/mail',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileSecurityRoute = AppProfileSecurityRouteImport.update({
  id: '/profile/security',
  path: '/profile/security',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdRoute = AppProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesIndexRoute = AppSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesEstimatesRoute = AppSalesEstimatesRouteImport.update({
  id: '/sales/estimates',
  path: '/sales/estimates',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesLeadsRoute = AppSalesLeadsRouteImport.update({
  id: '/sales/leads',
  path: '/sales/leads',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesPipelineRoute = AppSalesPipelineRouteImport.update({
  id: '/sales/pipeline',
  path: '/sales/pipeline',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesSummaryRoute = AppSalesSummaryRouteImport.update({
  id: '/sales/summary',
  path: '/sales/summary',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesTouchesRoute = AppSalesTouchesRouteImport.update({
  id: '/sales/touches',
  path: '/sales/touches',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAcquiringRoute = AppSettingsAcquiringRouteImport.update({
  id: '/acquiring',
  path: '/acquiring',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAiRoute = AppSettingsAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBankRoute = AppSettingsBankRouteImport.update({
  id: '/bank',
  path: '/bank',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCalendarRoute = AppSettingsCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCoefficientsRoute = AppSettingsCoefficientsRouteImport.update({
  id: '/coefficients',
  path: '/coefficients',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDadataRoute = AppSettingsDadataRouteImport.update({
  id: '/dadata',
  path: '/dadata',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDocumentsRoute = AppSettingsDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsEdoRoute = AppSettingsEdoRouteImport.update({
  id: '/edo',
  path: '/edo',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsFinanceRoute = AppSettingsFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMailRoute = AppSettingsMailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsPricingRoute = AppSettingsPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProductionRoute = AppSettingsProductionRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProposalsRoute = AppSettingsProposalsRouteImport.update({
  id: '/proposals',
  path: '/proposals',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsRolesRoute = AppSettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSalesRoute = AppSettingsSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSiteRoute = AppSettingsSiteRouteImport.update({
  id: '/site',
  path: '/site',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSpecializationsRoute =
  AppSettingsSpecializationsRouteImport.update({
    id: '/specializations',
    path: '/specializations',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsStudioRoute = AppSettingsStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTaxRoute = AppSettingsTaxRouteImport.update({
  id: '/tax',
  path: '/tax',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppTeamIndexRoute = AppTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamIdRoute = AppTeamIdRouteImport.update({
  id: '/team/$id',
  path: '/team/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppEstimatesRequestsIndexRoute =
  AppEstimatesRequestsIndexRouteImport.update({
    id: '/estimates/requests/',
    path: '/estimates/requests/',
    getParentRoute: () => AppRoute,
  } as any)
const AppEstimatesRequestsIdRoute = AppEstimatesRequestsIdRouteImport.update({
  id: '/estimates/requests/$id',
  path: '/estimates/requests/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMailMailboxIdFolderRoute = AppMailMailboxIdFolderRouteImport.update({
  id: '/mail/$mailboxId/$folder',
  path: '/mail/$mailboxId/$folder',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesDealsIdRoute = AppSalesDealsIdRouteImport.update({
  id: '/sales/deals/$id',
  path: '/sales/deals/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdTasksTaskIdRoute =
  AppProjectsIdTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AppProjectsIdRoute,
  } as any)
const AppSalesDealsIdBriefRoute = AppSalesDealsIdBriefRouteImport.update({
  id: '/sales/deals/$id_/brief',
  path: '/sales/deals/$id/brief',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesDealsIdContractRoute = AppSalesDealsIdContractRouteImport.update({
  id: '/sales/deals/$id_/contract',
  path: '/sales/deals/$id/contract',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesDealsIdEstimateRoute = AppSalesDealsIdEstimateRouteImport.update({
  id: '/sales/deals/$id_/estimate',
  path: '/sales/deals/$id/estimate',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesDealsIdProposalRoute = AppSalesDealsIdProposalRouteImport.update({
  id: '/sales/deals/$id_/proposal',
  path: '/sales/deals/$id/proposal',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesDealsIdQuickRoute = AppSalesDealsIdQuickRouteImport.update({
  id: '/sales/deals/$id_/quick',
  path: '/sales/deals/$id/quick',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/secure': typeof SecureRoute
  '/finance': typeof AppFinanceRoute
  '/messages': typeof AppMessagesRouteWithChildren
  '/news': typeof AppNewsRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/tasks': typeof AppTasksRoute
  '/today': typeof AppTodayRoute
  '/invite/$token': typeof InviteTokenRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/catalog/$id': typeof AppCatalogIdRoute
  '/catalog/cases': typeof AppCatalogCasesRoute
  '/clients/$id': typeof AppClientsIdRoute
  '/documents/$id': typeof AppDocumentsIdRoute
  '/messages/$conversationId': typeof AppMessagesConversationIdRoute
  '/messages/threads': typeof AppMessagesThreadsRoute
  '/profile/documents': typeof AppProfileDocumentsRoute
  '/profile/mail': typeof AppProfileMailRoute
  '/profile/security': typeof AppProfileSecurityRoute
  '/projects/$id': typeof AppProjectsIdRouteWithChildren
  '/sales/estimates': typeof AppSalesEstimatesRoute
  '/sales/leads': typeof AppSalesLeadsRoute
  '/sales/pipeline': typeof AppSalesPipelineRoute
  '/sales/summary': typeof AppSalesSummaryRoute
  '/sales/touches': typeof AppSalesTouchesRoute
  '/settings/acquiring': typeof AppSettingsAcquiringRoute
  '/settings/ai': typeof AppSettingsAiRoute
  '/settings/bank': typeof AppSettingsBankRoute
  '/settings/calendar': typeof AppSettingsCalendarRoute
  '/settings/coefficients': typeof AppSettingsCoefficientsRoute
  '/settings/dadata': typeof AppSettingsDadataRoute
  '/settings/documents': typeof AppSettingsDocumentsRoute
  '/settings/edo': typeof AppSettingsEdoRoute
  '/settings/finance': typeof AppSettingsFinanceRoute
  '/settings/mail': typeof AppSettingsMailRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/pricing': typeof AppSettingsPricingRoute
  '/settings/production': typeof AppSettingsProductionRoute
  '/settings/proposals': typeof AppSettingsProposalsRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/sales': typeof AppSettingsSalesRoute
  '/settings/site': typeof AppSettingsSiteRoute
  '/settings/specializations': typeof AppSettingsSpecializationsRoute
  '/settings/studio': typeof AppSettingsStudioRoute
  '/settings/tax': typeof AppSettingsTaxRoute
  '/team/$id': typeof AppTeamIdRoute
  '/catalog/': typeof AppCatalogIndexRoute
  '/clients/': typeof AppClientsIndexRoute
  '/documents/': typeof AppDocumentsIndexRoute
  '/mail/': typeof AppMailIndexRoute
  '/messages/': typeof AppMessagesIndexRoute
  '/profile/': typeof AppProfileIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/sales/': typeof AppSalesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/team/': typeof AppTeamIndexRoute
  '/estimates/requests/$id': typeof AppEstimatesRequestsIdRoute
  '/mail/$mailboxId/$folder': typeof AppMailMailboxIdFolderRoute
  '/sales/deals/$id': typeof AppSalesDealsIdRoute
  '/estimates/requests/': typeof AppEstimatesRequestsIndexRoute
  '/projects/$id/tasks/$taskId': typeof AppProjectsIdTasksTaskIdRoute
  '/sales/deals/$id/brief': typeof AppSalesDealsIdBriefRoute
  '/sales/deals/$id/contract': typeof AppSalesDealsIdContractRoute
  '/sales/deals/$id/estimate': typeof AppSalesDealsIdEstimateRoute
  '/sales/deals/$id/proposal': typeof AppSalesDealsIdProposalRoute
  '/sales/deals/$id/quick': typeof AppSalesDealsIdQuickRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/secure': typeof SecureRoute
  '/finance': typeof AppFinanceRoute
  '/news': typeof AppNewsRoute
  '/tasks': typeof AppTasksRoute
  '/today': typeof AppTodayRoute
  '/invite/$token': typeof InviteTokenRoute
  '/': typeof AppIndexRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/catalog/$id': typeof AppCatalogIdRoute
  '/catalog/cases': typeof AppCatalogCasesRoute
  '/clients/$id': typeof AppClientsIdRoute
  '/documents/$id': typeof AppDocumentsIdRoute
  '/messages/$conversationId': typeof AppMessagesConversationIdRoute
  '/messages/threads': typeof AppMessagesThreadsRoute
  '/profile/documents': typeof AppProfileDocumentsRoute
  '/profile/mail': typeof AppProfileMailRoute
  '/profile/security': typeof AppProfileSecurityRoute
  '/projects/$id': typeof AppProjectsIdRouteWithChildren
  '/sales/estimates': typeof AppSalesEstimatesRoute
  '/sales/leads': typeof AppSalesLeadsRoute
  '/sales/pipeline': typeof AppSalesPipelineRoute
  '/sales/summary': typeof AppSalesSummaryRoute
  '/sales/touches': typeof AppSalesTouchesRoute
  '/settings/acquiring': typeof AppSettingsAcquiringRoute
  '/settings/ai': typeof AppSettingsAiRoute
  '/settings/bank': typeof AppSettingsBankRoute
  '/settings/calendar': typeof AppSettingsCalendarRoute
  '/settings/coefficients': typeof AppSettingsCoefficientsRoute
  '/settings/dadata': typeof AppSettingsDadataRoute
  '/settings/documents': typeof AppSettingsDocumentsRoute
  '/settings/edo': typeof AppSettingsEdoRoute
  '/settings/finance': typeof AppSettingsFinanceRoute
  '/settings/mail': typeof AppSettingsMailRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/pricing': typeof AppSettingsPricingRoute
  '/settings/production': typeof AppSettingsProductionRoute
  '/settings/proposals': typeof AppSettingsProposalsRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/sales': typeof AppSettingsSalesRoute
  '/settings/site': typeof AppSettingsSiteRoute
  '/settings/specializations': typeof AppSettingsSpecializationsRoute
  '/settings/studio': typeof AppSettingsStudioRoute
  '/settings/tax': typeof AppSettingsTaxRoute
  '/team/$id': typeof AppTeamIdRoute
  '/catalog': typeof AppCatalogIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/documents': typeof AppDocumentsIndexRoute
  '/mail': typeof AppMailIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/sales': typeof AppSalesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/team': typeof AppTeamIndexRoute
  '/estimates/requests/$id': typeof AppEstimatesRequestsIdRoute
  '/mail/$mailboxId/$folder': typeof AppMailMailboxIdFolderRoute
  '/sales/deals/$id': typeof AppSalesDealsIdRoute
  '/estimates/requests': typeof AppEstimatesRequestsIndexRoute
  '/projects/$id/tasks/$taskId': typeof AppProjectsIdTasksTaskIdRoute
  '/sales/deals/$id/brief': typeof AppSalesDealsIdBriefRoute
  '/sales/deals/$id/contract': typeof AppSalesDealsIdContractRoute
  '/sales/deals/$id/estimate': typeof AppSalesDealsIdEstimateRoute
  '/sales/deals/$id/proposal': typeof AppSalesDealsIdProposalRoute
  '/sales/deals/$id/quick': typeof AppSalesDealsIdQuickRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/secure': typeof SecureRoute
  '/_app/finance': typeof AppFinanceRoute
  '/_app/messages': typeof AppMessagesRouteWithChildren
  '/_app/news': typeof AppNewsRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/tasks': typeof AppTasksRoute
  '/_app/today': typeof AppTodayRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/catalog/$id': typeof AppCatalogIdRoute
  '/_app/catalog/cases': typeof AppCatalogCasesRoute
  '/_app/clients/$id': typeof AppClientsIdRoute
  '/_app/documents/$id': typeof AppDocumentsIdRoute
  '/_app/messages/$conversationId': typeof AppMessagesConversationIdRoute
  '/_app/messages/threads': typeof AppMessagesThreadsRoute
  '/_app/profile/documents': typeof AppProfileDocumentsRoute
  '/_app/profile/mail': typeof AppProfileMailRoute
  '/_app/profile/security': typeof AppProfileSecurityRoute
  '/_app/projects/$id': typeof AppProjectsIdRouteWithChildren
  '/_app/sales/estimates': typeof AppSalesEstimatesRoute
  '/_app/sales/leads': typeof AppSalesLeadsRoute
  '/_app/sales/pipeline': typeof AppSalesPipelineRoute
  '/_app/sales/summary': typeof AppSalesSummaryRoute
  '/_app/sales/touches': typeof AppSalesTouchesRoute
  '/_app/settings/acquiring': typeof AppSettingsAcquiringRoute
  '/_app/settings/ai': typeof AppSettingsAiRoute
  '/_app/settings/bank': typeof AppSettingsBankRoute
  '/_app/settings/calendar': typeof AppSettingsCalendarRoute
  '/_app/settings/coefficients': typeof AppSettingsCoefficientsRoute
  '/_app/settings/dadata': typeof AppSettingsDadataRoute
  '/_app/settings/documents': typeof AppSettingsDocumentsRoute
  '/_app/settings/edo': typeof AppSettingsEdoRoute
  '/_app/settings/finance': typeof AppSettingsFinanceRoute
  '/_app/settings/mail': typeof AppSettingsMailRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/pricing': typeof AppSettingsPricingRoute
  '/_app/settings/production': typeof AppSettingsProductionRoute
  '/_app/settings/proposals': typeof AppSettingsProposalsRoute
  '/_app/settings/roles': typeof AppSettingsRolesRoute
  '/_app/settings/sales': typeof AppSettingsSalesRoute
  '/_app/settings/site': typeof AppSettingsSiteRoute
  '/_app/settings/specializations': typeof AppSettingsSpecializationsRoute
  '/_app/settings/studio': typeof AppSettingsStudioRoute
  '/_app/settings/tax': typeof AppSettingsTaxRoute
  '/_app/team/$id': typeof AppTeamIdRoute
  '/_app/catalog/': typeof AppCatalogIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/documents/': typeof AppDocumentsIndexRoute
  '/_app/mail/': typeof AppMailIndexRoute
  '/_app/messages/': typeof AppMessagesIndexRoute
  '/_app/profile/': typeof AppProfileIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/sales/': typeof AppSalesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/team/': typeof AppTeamIndexRoute
  '/_app/estimates/requests/$id': typeof AppEstimatesRequestsIdRoute
  '/_app/mail/$mailboxId/$folder': typeof AppMailMailboxIdFolderRoute
  '/_app/sales/deals/$id': typeof AppSalesDealsIdRoute
  '/_app/estimates/requests/': typeof AppEstimatesRequestsIndexRoute
  '/_app/projects/$id/tasks/$taskId': typeof AppProjectsIdTasksTaskIdRoute
  '/_app/sales/deals/$id_/brief': typeof AppSalesDealsIdBriefRoute
  '/_app/sales/deals/$id_/contract': typeof AppSalesDealsIdContractRoute
  '/_app/sales/deals/$id_/estimate': typeof AppSalesDealsIdEstimateRoute
  '/_app/sales/deals/$id_/proposal': typeof AppSalesDealsIdProposalRoute
  '/_app/sales/deals/$id_/quick': typeof AppSalesDealsIdQuickRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/secure'
    | '/finance'
    | '/messages'
    | '/news'
    | '/settings'
    | '/tasks'
    | '/today'
    | '/invite/$token'
    | '/admin/audit'
    | '/catalog/$id'
    | '/catalog/cases'
    | '/clients/$id'
    | '/documents/$id'
    | '/messages/$conversationId'
    | '/messages/threads'
    | '/profile/documents'
    | '/profile/mail'
    | '/profile/security'
    | '/projects/$id'
    | '/sales/estimates'
    | '/sales/leads'
    | '/sales/pipeline'
    | '/sales/summary'
    | '/sales/touches'
    | '/settings/acquiring'
    | '/settings/ai'
    | '/settings/bank'
    | '/settings/calendar'
    | '/settings/coefficients'
    | '/settings/dadata'
    | '/settings/documents'
    | '/settings/edo'
    | '/settings/finance'
    | '/settings/mail'
    | '/settings/notifications'
    | '/settings/pricing'
    | '/settings/production'
    | '/settings/proposals'
    | '/settings/roles'
    | '/settings/sales'
    | '/settings/site'
    | '/settings/specializations'
    | '/settings/studio'
    | '/settings/tax'
    | '/team/$id'
    | '/catalog/'
    | '/clients/'
    | '/documents/'
    | '/mail/'
    | '/messages/'
    | '/profile/'
    | '/projects/'
    | '/sales/'
    | '/settings/'
    | '/team/'
    | '/estimates/requests/$id'
    | '/mail/$mailboxId/$folder'
    | '/sales/deals/$id'
    | '/estimates/requests/'
    | '/projects/$id/tasks/$taskId'
    | '/sales/deals/$id/brief'
    | '/sales/deals/$id/contract'
    | '/sales/deals/$id/estimate'
    | '/sales/deals/$id/proposal'
    | '/sales/deals/$id/quick'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/secure'
    | '/finance'
    | '/news'
    | '/tasks'
    | '/today'
    | '/invite/$token'
    | '/'
    | '/admin/audit'
    | '/catalog/$id'
    | '/catalog/cases'
    | '/clients/$id'
    | '/documents/$id'
    | '/messages/$conversationId'
    | '/messages/threads'
    | '/profile/documents'
    | '/profile/mail'
    | '/profile/security'
    | '/projects/$id'
    | '/sales/estimates'
    | '/sales/leads'
    | '/sales/pipeline'
    | '/sales/summary'
    | '/sales/touches'
    | '/settings/acquiring'
    | '/settings/ai'
    | '/settings/bank'
    | '/settings/calendar'
    | '/settings/coefficients'
    | '/settings/dadata'
    | '/settings/documents'
    | '/settings/edo'
    | '/settings/finance'
    | '/settings/mail'
    | '/settings/notifications'
    | '/settings/pricing'
    | '/settings/production'
    | '/settings/proposals'
    | '/settings/roles'
    | '/settings/sales'
    | '/settings/site'
    | '/settings/specializations'
    | '/settings/studio'
    | '/settings/tax'
    | '/team/$id'
    | '/catalog'
    | '/clients'
    | '/documents'
    | '/mail'
    | '/messages'
    | '/profile'
    | '/projects'
    | '/sales'
    | '/settings'
    | '/team'
    | '/estimates/requests/$id'
    | '/mail/$mailboxId/$folder'
    | '/sales/deals/$id'
    | '/estimates/requests'
    | '/projects/$id/tasks/$taskId'
    | '/sales/deals/$id/brief'
    | '/sales/deals/$id/contract'
    | '/sales/deals/$id/estimate'
    | '/sales/deals/$id/proposal'
    | '/sales/deals/$id/quick'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/secure'
    | '/_app/finance'
    | '/_app/messages'
    | '/_app/news'
    | '/_app/settings'
    | '/_app/tasks'
    | '/_app/today'
    | '/invite/$token'
    | '/_app/'
    | '/_app/admin/audit'
    | '/_app/catalog/$id'
    | '/_app/catalog/cases'
    | '/_app/clients/$id'
    | '/_app/documents/$id'
    | '/_app/messages/$conversationId'
    | '/_app/messages/threads'
    | '/_app/profile/documents'
    | '/_app/profile/mail'
    | '/_app/profile/security'
    | '/_app/projects/$id'
    | '/_app/sales/estimates'
    | '/_app/sales/leads'
    | '/_app/sales/pipeline'
    | '/_app/sales/summary'
    | '/_app/sales/touches'
    | '/_app/settings/acquiring'
    | '/_app/settings/ai'
    | '/_app/settings/bank'
    | '/_app/settings/calendar'
    | '/_app/settings/coefficients'
    | '/_app/settings/dadata'
    | '/_app/settings/documents'
    | '/_app/settings/edo'
    | '/_app/settings/finance'
    | '/_app/settings/mail'
    | '/_app/settings/notifications'
    | '/_app/settings/pricing'
    | '/_app/settings/production'
    | '/_app/settings/proposals'
    | '/_app/settings/roles'
    | '/_app/settings/sales'
    | '/_app/settings/site'
    | '/_app/settings/specializations'
    | '/_app/settings/studio'
    | '/_app/settings/tax'
    | '/_app/team/$id'
    | '/_app/catalog/'
    | '/_app/clients/'
    | '/_app/documents/'
    | '/_app/mail/'
    | '/_app/messages/'
    | '/_app/profile/'
    | '/_app/projects/'
    | '/_app/sales/'
    | '/_app/settings/'
    | '/_app/team/'
    | '/_app/estimates/requests/$id'
    | '/_app/mail/$mailboxId/$folder'
    | '/_app/sales/deals/$id'
    | '/_app/estimates/requests/'
    | '/_app/projects/$id/tasks/$taskId'
    | '/_app/sales/deals/$id_/brief'
    | '/_app/sales/deals/$id_/contract'
    | '/_app/sales/deals/$id_/estimate'
    | '/_app/sales/deals/$id_/proposal'
    | '/_app/sales/deals/$id_/quick'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SecureRoute: typeof SecureRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secure': {
      id: '/secure'
      path: '/secure'
      fullPath: '/secure'
      preLoaderRoute: typeof SecureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance': {
      id: '/_app/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AppFinanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/news': {
      id: '/_app/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof AppNewsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/today': {
      id: '/_app/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AppTodayRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/': {
      id: '/_app/catalog/'
      path: '/catalog'
      fullPath: '/catalog/'
      preLoaderRoute: typeof AppCatalogIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/$id': {
      id: '/_app/catalog/$id'
      path: '/catalog/$id'
      fullPath: '/catalog/$id'
      preLoaderRoute: typeof AppCatalogIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/cases': {
      id: '/_app/catalog/cases'
      path: '/catalog/cases'
      fullPath: '/catalog/cases'
      preLoaderRoute: typeof AppCatalogCasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$id': {
      id: '/_app/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof AppClientsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/': {
      id: '/_app/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/$id': {
      id: '/_app/documents/$id'
      path: '/documents/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof AppDocumentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mail/': {
      id: '/_app/mail/'
      path: '/mail'
      fullPath: '/mail/'
      preLoaderRoute: typeof AppMailIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages/': {
      id: '/_app/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof AppMessagesIndexRouteImport
      parentRoute: typeof AppMessagesRoute
    }
    '/_app/messages/$conversationId': {
      id: '/_app/messages/$conversationId'
      path: '/$conversationId'
      fullPath: '/messages/$conversationId'
      preLoaderRoute: typeof AppMessagesConversationIdRouteImport
      parentRoute: typeof AppMessagesRoute
    }
    '/_app/messages/threads': {
      id: '/_app/messages/threads'
      path: '/threads'
      fullPath: '/messages/threads'
      preLoaderRoute: typeof AppMessagesThreadsRouteImport
      parentRoute: typeof AppMessagesRoute
    }
    '/_app/profile/': {
      id: '/_app/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AppProfileIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/documents': {
      id: '/_app/profile/documents'
      path: '/profile/documents'
      fullPath: '/profile/documents'
      preLoaderRoute: typeof AppProfileDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/mail': {
      id: '/_app/profile/mail'
      path: '/profile/mail'
      fullPath: '/profile/mail'
      preLoaderRoute: typeof AppProfileMailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/security': {
      id: '/_app/profile/security'
      path: '/profile/security'
      fullPath: '/profile/security'
      preLoaderRoute: typeof AppProfileSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id': {
      id: '/_app/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof AppProjectsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/': {
      id: '/_app/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof AppSalesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/estimates': {
      id: '/_app/sales/estimates'
      path: '/sales/estimates'
      fullPath: '/sales/estimates'
      preLoaderRoute: typeof AppSalesEstimatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/leads': {
      id: '/_app/sales/leads'
      path: '/sales/leads'
      fullPath: '/sales/leads'
      preLoaderRoute: typeof AppSalesLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/pipeline': {
      id: '/_app/sales/pipeline'
      path: '/sales/pipeline'
      fullPath: '/sales/pipeline'
      preLoaderRoute: typeof AppSalesPipelineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/summary': {
      id: '/_app/sales/summary'
      path: '/sales/summary'
      fullPath: '/sales/summary'
      preLoaderRoute: typeof AppSalesSummaryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/touches': {
      id: '/_app/sales/touches'
      path: '/sales/touches'
      fullPath: '/sales/touches'
      preLoaderRoute: typeof AppSalesTouchesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/acquiring': {
      id: '/_app/settings/acquiring'
      path: '/acquiring'
      fullPath: '/settings/acquiring'
      preLoaderRoute: typeof AppSettingsAcquiringRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/ai': {
      id: '/_app/settings/ai'
      path: '/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof AppSettingsAiRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/bank': {
      id: '/_app/settings/bank'
      path: '/bank'
      fullPath: '/settings/bank'
      preLoaderRoute: typeof AppSettingsBankRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/calendar': {
      id: '/_app/settings/calendar'
      path: '/calendar'
      fullPath: '/settings/calendar'
      preLoaderRoute: typeof AppSettingsCalendarRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/coefficients': {
      id: '/_app/settings/coefficients'
      path: '/coefficients'
      fullPath: '/settings/coefficients'
      preLoaderRoute: typeof AppSettingsCoefficientsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/dadata': {
      id: '/_app/settings/dadata'
      path: '/dadata'
      fullPath: '/settings/dadata'
      preLoaderRoute: typeof AppSettingsDadataRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/documents': {
      id: '/_app/settings/documents'
      path: '/documents'
      fullPath: '/settings/documents'
      preLoaderRoute: typeof AppSettingsDocumentsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/edo': {
      id: '/_app/settings/edo'
      path: '/edo'
      fullPath: '/settings/edo'
      preLoaderRoute: typeof AppSettingsEdoRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/finance': {
      id: '/_app/settings/finance'
      path: '/finance'
      fullPath: '/settings/finance'
      preLoaderRoute: typeof AppSettingsFinanceRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/mail': {
      id: '/_app/settings/mail'
      path: '/mail'
      fullPath: '/settings/mail'
      preLoaderRoute: typeof AppSettingsMailRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/pricing': {
      id: '/_app/settings/pricing'
      path: '/pricing'
      fullPath: '/settings/pricing'
      preLoaderRoute: typeof AppSettingsPricingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/production': {
      id: '/_app/settings/production'
      path: '/production'
      fullPath: '/settings/production'
      preLoaderRoute: typeof AppSettingsProductionRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/proposals': {
      id: '/_app/settings/proposals'
      path: '/proposals'
      fullPath: '/settings/proposals'
      preLoaderRoute: typeof AppSettingsProposalsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/roles': {
      id: '/_app/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AppSettingsRolesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/sales': {
      id: '/_app/settings/sales'
      path: '/sales'
      fullPath: '/settings/sales'
      preLoaderRoute: typeof AppSettingsSalesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/site': {
      id: '/_app/settings/site'
      path: '/site'
      fullPath: '/settings/site'
      preLoaderRoute: typeof AppSettingsSiteRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/specializations': {
      id: '/_app/settings/specializations'
      path: '/specializations'
      fullPath: '/settings/specializations'
      preLoaderRoute: typeof AppSettingsSpecializationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/studio': {
      id: '/_app/settings/studio'
      path: '/studio'
      fullPath: '/settings/studio'
      preLoaderRoute: typeof AppSettingsStudioRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/tax': {
      id: '/_app/settings/tax'
      path: '/tax'
      fullPath: '/settings/tax'
      preLoaderRoute: typeof AppSettingsTaxRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/team/': {
      id: '/_app/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof AppTeamIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team/$id': {
      id: '/_app/team/$id'
      path: '/team/$id'
      fullPath: '/team/$id'
      preLoaderRoute: typeof AppTeamIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/estimates/requests/': {
      id: '/_app/estimates/requests/'
      path: '/estimates/requests'
      fullPath: '/estimates/requests/'
      preLoaderRoute: typeof AppEstimatesRequestsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/estimates/requests/$id': {
      id: '/_app/estimates/requests/$id'
      path: '/estimates/requests/$id'
      fullPath: '/estimates/requests/$id'
      preLoaderRoute: typeof AppEstimatesRequestsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mail/$mailboxId/$folder': {
      id: '/_app/mail/$mailboxId/$folder'
      path: '/mail/$mailboxId/$folder'
      fullPath: '/mail/$mailboxId/$folder'
      preLoaderRoute: typeof AppMailMailboxIdFolderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/deals/$id': {
      id: '/_app/sales/deals/$id'
      path: '/sales/deals/$id'
      fullPath: '/sales/deals/$id'
      preLoaderRoute: typeof AppSalesDealsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id/tasks/$taskId': {
      id: '/_app/projects/$id/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/projects/$id/tasks/$taskId'
      preLoaderRoute: typeof AppProjectsIdTasksTaskIdRouteImport
      parentRoute: typeof AppProjectsIdRoute
    }
    '/_app/sales/deals/$id_/brief': {
      id: '/_app/sales/deals/$id_/brief'
      path: '/sales/deals/$id/brief'
      fullPath: '/sales/deals/$id/brief'
      preLoaderRoute: typeof AppSalesDealsIdBriefRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/deals/$id_/contract': {
      id: '/_app/sales/deals/$id_/contract'
      path: '/sales/deals/$id/contract'
      fullPath: '/sales/deals/$id/contract'
      preLoaderRoute: typeof AppSalesDealsIdContractRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/deals/$id_/estimate': {
      id: '/_app/sales/deals/$id_/estimate'
      path: '/sales/deals/$id/estimate'
      fullPath: '/sales/deals/$id/estimate'
      preLoaderRoute: typeof AppSalesDealsIdEstimateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/deals/$id_/proposal': {
      id: '/_app/sales/deals/$id_/proposal'
      path: '/sales/deals/$id/proposal'
      fullPath: '/sales/deals/$id/proposal'
      preLoaderRoute: typeof AppSalesDealsIdProposalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/deals/$id_/quick': {
      id: '/_app/sales/deals/$id_/quick'
      path: '/sales/deals/$id/quick'
      fullPath: '/sales/deals/$id/quick'
      preLoaderRoute: typeof AppSalesDealsIdQuickRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppMessagesRouteChildren {
  AppMessagesConversationIdRoute: typeof AppMessagesConversationIdRoute
  AppMessagesThreadsRoute: typeof AppMessagesThreadsRoute
  AppMessagesIndexRoute: typeof AppMessagesIndexRoute
}

const AppMessagesRouteChildren: AppMessagesRouteChildren = {
  AppMessagesConversationIdRoute: AppMessagesConversationIdRoute,
  AppMessagesThreadsRoute: AppMessagesThreadsRoute,
  AppMessagesIndexRoute: AppMessagesIndexRoute,
}

const AppMessagesRouteWithChildren = AppMessagesRoute._addFileChildren(
  AppMessagesRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAcquiringRoute: typeof AppSettingsAcquiringRoute
  AppSettingsAiRoute: typeof AppSettingsAiRoute
  AppSettingsBankRoute: typeof AppSettingsBankRoute
  AppSettingsCalendarRoute: typeof AppSettingsCalendarRoute
  AppSettingsCoefficientsRoute: typeof AppSettingsCoefficientsRoute
  AppSettingsDadataRoute: typeof AppSettingsDadataRoute
  AppSettingsDocumentsRoute: typeof AppSettingsDocumentsRoute
  AppSettingsEdoRoute: typeof AppSettingsEdoRoute
  AppSettingsFinanceRoute: typeof AppSettingsFinanceRoute
  AppSettingsMailRoute: typeof AppSettingsMailRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsPricingRoute: typeof AppSettingsPricingRoute
  AppSettingsProductionRoute: typeof AppSettingsProductionRoute
  AppSettingsProposalsRoute: typeof AppSettingsProposalsRoute
  AppSettingsRolesRoute: typeof AppSettingsRolesRoute
  AppSettingsSalesRoute: typeof AppSettingsSalesRoute
  AppSettingsSiteRoute: typeof AppSettingsSiteRoute
  AppSettingsSpecializationsRoute: typeof AppSettingsSpecializationsRoute
  AppSettingsStudioRoute: typeof AppSettingsStudioRoute
  AppSettingsTaxRoute: typeof AppSettingsTaxRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAcquiringRoute: AppSettingsAcquiringRoute,
  AppSettingsAiRoute: AppSettingsAiRoute,
  AppSettingsBankRoute: AppSettingsBankRoute,
  AppSettingsCalendarRoute: AppSettingsCalendarRoute,
  AppSettingsCoefficientsRoute: AppSettingsCoefficientsRoute,
  AppSettingsDadataRoute: AppSettingsDadataRoute,
  AppSettingsDocumentsRoute: AppSettingsDocumentsRoute,
  AppSettingsEdoRoute: AppSettingsEdoRoute,
  AppSettingsFinanceRoute: AppSettingsFinanceRoute,
  AppSettingsMailRoute: AppSettingsMailRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsPricingRoute: AppSettingsPricingRoute,
  AppSettingsProductionRoute: AppSettingsProductionRoute,
  AppSettingsProposalsRoute: AppSettingsProposalsRoute,
  AppSettingsRolesRoute: AppSettingsRolesRoute,
  AppSettingsSalesRoute: AppSettingsSalesRoute,
  AppSettingsSiteRoute: AppSettingsSiteRoute,
  AppSettingsSpecializationsRoute: AppSettingsSpecializationsRoute,
  AppSettingsStudioRoute: AppSettingsStudioRoute,
  AppSettingsTaxRoute: AppSettingsTaxRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppProjectsIdRouteChildren {
  AppProjectsIdTasksTaskIdRoute: typeof AppProjectsIdTasksTaskIdRoute
}

const AppProjectsIdRouteChildren: AppProjectsIdRouteChildren = {
  AppProjectsIdTasksTaskIdRoute: AppProjectsIdTasksTaskIdRoute,
}

const AppProjectsIdRouteWithChildren = AppProjectsIdRoute._addFileChildren(
  AppProjectsIdRouteChildren,
)

interface AppRouteChildren {
  AppFinanceRoute: typeof AppFinanceRoute
  AppMessagesRoute: typeof AppMessagesRouteWithChildren
  AppNewsRoute: typeof AppNewsRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTasksRoute: typeof AppTasksRoute
  AppTodayRoute: typeof AppTodayRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppCatalogIdRoute: typeof AppCatalogIdRoute
  AppCatalogCasesRoute: typeof AppCatalogCasesRoute
  AppClientsIdRoute: typeof AppClientsIdRoute
  AppDocumentsIdRoute: typeof AppDocumentsIdRoute
  AppProfileDocumentsRoute: typeof AppProfileDocumentsRoute
  AppProfileMailRoute: typeof AppProfileMailRoute
  AppProfileSecurityRoute: typeof AppProfileSecurityRoute
  AppProjectsIdRoute: typeof AppProjectsIdRouteWithChildren
  AppSalesEstimatesRoute: typeof AppSalesEstimatesRoute
  AppSalesLeadsRoute: typeof AppSalesLeadsRoute
  AppSalesPipelineRoute: typeof AppSalesPipelineRoute
  AppSalesSummaryRoute: typeof AppSalesSummaryRoute
  AppSalesTouchesRoute: typeof AppSalesTouchesRoute
  AppTeamIdRoute: typeof AppTeamIdRoute
  AppCatalogIndexRoute: typeof AppCatalogIndexRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
  AppMailIndexRoute: typeof AppMailIndexRoute
  AppProfileIndexRoute: typeof AppProfileIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppSalesIndexRoute: typeof AppSalesIndexRoute
  AppTeamIndexRoute: typeof AppTeamIndexRoute
  AppEstimatesRequestsIdRoute: typeof AppEstimatesRequestsIdRoute
  AppMailMailboxIdFolderRoute: typeof AppMailMailboxIdFolderRoute
  AppSalesDealsIdRoute: typeof AppSalesDealsIdRoute
  AppEstimatesRequestsIndexRoute: typeof AppEstimatesRequestsIndexRoute
  AppSalesDealsIdBriefRoute: typeof AppSalesDealsIdBriefRoute
  AppSalesDealsIdContractRoute: typeof AppSalesDealsIdContractRoute
  AppSalesDealsIdEstimateRoute: typeof AppSalesDealsIdEstimateRoute
  AppSalesDealsIdProposalRoute: typeof AppSalesDealsIdProposalRoute
  AppSalesDealsIdQuickRoute: typeof AppSalesDealsIdQuickRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppFinanceRoute: AppFinanceRoute,
  AppMessagesRoute: AppMessagesRouteWithChildren,
  AppNewsRoute: AppNewsRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTasksRoute: AppTasksRoute,
  AppTodayRoute: AppTodayRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppCatalogIdRoute: AppCatalogIdRoute,
  AppCatalogCasesRoute: AppCatalogCasesRoute,
  AppClientsIdRoute: AppClientsIdRoute,
  AppDocumentsIdRoute: AppDocumentsIdRoute,
  AppProfileDocumentsRoute: AppProfileDocumentsRoute,
  AppProfileMailRoute: AppProfileMailRoute,
  AppProfileSecurityRoute: AppProfileSecurityRoute,
  AppProjectsIdRoute: AppProjectsIdRouteWithChildren,
  AppSalesEstimatesRoute: AppSalesEstimatesRoute,
  AppSalesLeadsRoute: AppSalesLeadsRoute,
  AppSalesPipelineRoute: AppSalesPipelineRoute,
  AppSalesSummaryRoute: AppSalesSummaryRoute,
  AppSalesTouchesRoute: AppSalesTouchesRoute,
  AppTeamIdRoute: AppTeamIdRoute,
  AppCatalogIndexRoute: AppCatalogIndexRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
  AppMailIndexRoute: AppMailIndexRoute,
  AppProfileIndexRoute: AppProfileIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppSalesIndexRoute: AppSalesIndexRoute,
  AppTeamIndexRoute: AppTeamIndexRoute,
  AppEstimatesRequestsIdRoute: AppEstimatesRequestsIdRoute,
  AppMailMailboxIdFolderRoute: AppMailMailboxIdFolderRoute,
  AppSalesDealsIdRoute: AppSalesDealsIdRoute,
  AppEstimatesRequestsIndexRoute: AppEstimatesRequestsIndexRoute,
  AppSalesDealsIdBriefRoute: AppSalesDealsIdBriefRoute,
  AppSalesDealsIdContractRoute: AppSalesDealsIdContractRoute,
  AppSalesDealsIdEstimateRoute: AppSalesDealsIdEstimateRoute,
  AppSalesDealsIdProposalRoute: AppSalesDealsIdProposalRoute,
  AppSalesDealsIdQuickRoute: AppSalesDealsIdQuickRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SecureRoute: SecureRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
